import { computed } from "vue";
import { useFavoriteStore } from "@/store/modules/favorite";
import { useShelfStore } from "@/store/modules/shelf";
import { presentToastWithOptions } from "@/utils/functions";

export const useFavorite = () => {
    const favoriteStore = useFavoriteStore();
    const shelfStore = useShelfStore();
    
    const favorite = computed(() => favoriteStore.favorite);
    const favorites = computed(() => favoriteStore.getFavorites);
    const favoriteProducts = computed(() => favoriteStore.getFavorites?.favoriteProducts);
    const favoriteBrands = computed(() => favoriteStore.getFavorites?.favoriteBrands);
    const favoriteEvents = computed(() => favoriteStore.getFavorites?.favoriteEvents);
    const favoriteRoutines = computed(() => favoriteStore.getFavorites?.favoriteRoutines);
    const shelves = computed(() => shelfStore.shelves);

    const recommandShelves = computed(() => {
        const shelvesIds = shelves.value.map((item: any) => item?.product?.id);
        const products = favoriteProducts.value.filter((item: any) => !shelvesIds.includes(item?.product?.id));
        return products;
    })

    const onAddFavorite = async (data: any) => {
        const result = await favoriteStore.axCreateFavorite(data);
        if (result)
            presentToastWithOptions(
              `This ${data?.type} is added into your favorite list.`,
              "success",
              "top"
            );
        else
            presentToastWithOptions(
                `This ${data?.type} is added into your favorite list.`,
                "danger",
            );
    }

    const getFavorite = async (data: any) => {
        await favoriteStore.axFavorite(data);
    }

    const onDeleteFavorite = async (id: string, type: string) => {
        const result = await favoriteStore.axDeleteFavorite(id);
        if (result)
            presentToastWithOptions(
              `This ${type} is removed from your favorite list.`,
              "success",
              "top"
            );
        else
            presentToastWithOptions(
                `Removing this ${type} from your favorite list failed.`,
                "danger",
            );
    }
    
    return {
        favorite,
        favorites,
        favoriteProducts,
        favoriteBrands,
        favoriteEvents,
        favoriteRoutines,
        recommandShelves,
        getFavorite,
        onAddFavorite,
        onDeleteFavorite
    }
}